const linkedInPosterNorwegian = {
  messages: {
    connectionError: "Det oppstod en feil ved kontroll av dine tilkoblinger",
    codeGenerationError: "Det oppstod en feil ved generering av tilkoblingskode. Prøv igjen senere.",
    workflowTestSuccess: "LinkedIn-innlegg sendt via Telegram! Sjekk din Telegram-chat.",
    workflowTestError: "Feil ved testing av arbeidsflyt. Sjekk konsollen for detaljer.",
    linkedInDisconnectError: "Det oppstod en feil ved frakobling av LinkedIn: {message}",
    telegramDisconnectError: "Det oppstod en feil ved frakobling av Telegram: {message}",
    deliveryPreferenceError: "Det oppstod en feil ved oppsett av leveringspreferanse: {message}"
  }
};

export default linkedInPosterNorwegian; 